import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'


const HeaderLeftDiv = tw.div`
  flex
  flex-shrink
  text-4xl
  md:text-6xl
  lg:text-7xl
  leading-relaxed
  text-redarkbeige
  font-bold
  uppercase
  font-header
  w-full
  border-b
  border-relightnavy
`




const HeaderLeft = (props) => {

  return (
    <HeaderLeftDiv> {props.text} </HeaderLeftDiv>
  )
}


export default HeaderLeft
